"use client";

import { Button } from "@resume-studio/ui";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles, CheckCircle2 } from "lucide-react";
import Link from "next/link";
import Image from "next/image";

export function StickySidebarCTA() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
      className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#1a1a1a] to-[#2d2d2d] text-white shadow-2xl group"
    >
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary/20 rounded-full blur-3xl -mr-32 -mt-32 transition-all duration-700 group-hover:bg-primary/30" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-500/20 rounded-full blur-3xl -ml-24 -mb-24 transition-all duration-700 group-hover:bg-blue-500/30" />

      <div className="relative p-8 flex flex-col items-center text-center">
        {/* Floating Icon/Badge */}
        <motion.div
          animate={{ y: [0, -5, 0] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          className="mb-6 relative"
        >
          <div className="absolute inset-0 bg-primary/50 blur-xl rounded-full" />
          <div className="relative w-16 h-16 bg-gradient-to-br from-primary to-blue-600 rounded-2xl flex items-center justify-center shadow-lg border border-white/10">
            <Sparkles className="w-8 h-8 text-white" />
          </div>
        </motion.div>

        <h3 className="text-2xl font-bold mb-3 leading-tight">Ready to Land Your Dream Job?</h3>

        <p className="text-gray-300 mb-6 text-base leading-relaxed">
          Stop guessing what recruiters want. Create a professional, ATS-optimized resume in minutes
          with our AI builder.
        </p>

        {/* Feature List */}
        <div className="flex flex-col gap-2 w-full mb-8 text-left pl-2">
          {["ATS-Friendly Templates", "AI Content Suggestions", "Real-time Score Check"].map(
            (feature, i) => (
              <div key={i} className="flex items-center gap-3 text-sm text-gray-300">
                <CheckCircle2 className="w-4 h-4 text-primary flex-shrink-0" />
                <span>{feature}</span>
              </div>
            ),
          )}
        </div>

        <Link href={`${process.env.NEXT_PUBLIC_APP_URL}/try`} className="w-full">
          <Button className="w-full h-12 bg-white text-gray-900 hover:bg-gray-100 hover:scale-[1.02] active:scale-[0.98] font-bold text-base rounded-xl shadow-lg transition-all duration-200 flex items-center justify-center gap-2 group/btn">
            Build My Resume
            <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
          </Button>
        </Link>

        <p className="mt-4 text-xs text-gray-500 font-medium">No credit card required</p>
      </div>
    </motion.div>
  );
}
